import axios from "axios";

const baseURLs = {
//  CLIENT: "http://localhost:8093",
//  AUTH: "http://localhost:8092",
//  ADMIN: "http://localhost:8091",
//  NOTIFY: "http://localhost:8094",
//  REACT: "http://localhost:3000",
//  NOTIFICATION: "ws://localhost:8094/ws/notifications",

  //QA Environment
  //CLIENT: "http://172.236.189.103:8093",
  //AUTH: "http://172.236.189.103:8092",
  //ADMIN: "http://172.236.189.103:8091",
  //NOTIFY: "http://172.236.189.103:8094",
  //REACT: "http://localhost:3000",
  // REACT: "http://139.144.4.104:3000",
  //NOTIFICATION: "ws://172.236.189.103:8094/ws/notifications",

  //Production URLs
  //  CLIENT: "https://backend.bookmytuitions.com:445",
  //  AUTH: "https://backend.bookmytuitions.com:444",
  //  ADMIN: "https://backend.bookmytuitions.com:443",
  //  NOTIFY: "https://backend.bookmytuitions.com:446",
  //  REACT: "https://bookmytuitions.com",
  //  NOTIFICATION: "wss://backend.bookmytuitions.com:446/wss/notifications",
  // Production URLs — all through port 443
  
 CLIENT: "https://backend.bookmytuitions.com/client",
 AUTH:   "https://backend.bookmytuitions.com/auth",
 ADMIN:  "https://backend.bookmytuitions.com/admin",
 NOTIFY: "https://backend.bookmytuitions.com/notification",
 NOTIFICATION: "wss://backend.bookmytuitions.com/wss/notifications",

};

// const adminToken =
//   "eyJhbGciOiJIUzI1NiJ9.eyJlbnZpcm9ubWVudCI6ImxvY2FsIiwibW9kdWxlIjoiYWRtaW4iLCJwcm9qZWN0IjoibXl0dWl0aW9uY2VudGVyIiwic3ViIjoibXRjQGxvY2FsIn0.2TQhtUguggpUJSNW7Y1H3Q5a1gSe-CrXYMq3TzAWVGo";

// const authToken =
//   "eyJhbGciOiJIUzI1NiJ9.eyJlbnZpcm9ubWVudCI6ImxvY2FsIiwibW9kdWxlIjoiYXV0aCIsInByb2plY3QiOiJteXR1aXRpb25jZW50ZXIiLCJzdWIiOiJtdGNAbG9jYWwifQ.3iUV-nTMaei5_C2AKSwfRxzLIdZFZQgAIAhuNxaA-lI";

// const clientToken =
//   "eyJhbGciOiJIUzI1NiJ9.eyJlbnZpcm9ubWVudCI6ImxvY2FsIiwibW9kdWxlIjoiY2xpZW50IiwicHJvamVjdCI6Im15dHVpdGlvbmNlbnRlciIsInN1YiI6Im10Y0Bsb2NhbCJ9.XLIkQczXorOAo0wxpbarhzAyjRWmD_LQpIxSSPx5rZI";

const clientAPI = axios.create({
  baseURL: `${baseURLs.CLIENT}/bookmytuition`,
  // headers: {
  //   Authorization: `Bearer ${clientToken}`,
  // },
});

const authAPI = axios.create({
  baseURL: `${baseURLs.AUTH}/bookmytuition`,
  // headers: {
  //   Authorization: `Bearer ${authToken}`,
  // },
});

const adminAPI = axios.create({
  baseURL: `${baseURLs.ADMIN}/bookmytuition`,
  // headers: {
  //   Authorization: `Bearer ${adminToken}`,
  // },
});

const notifyAPI = axios.create({
  baseURL: `${baseURLs.NOTIFY}/bookmytuition`,
  // headers: {
  //   Authorization: `Bearer ${authToken}`,
  // },
});

const reactURL = axios.create({
  baseURL: baseURLs.REACT,
});

export { clientAPI, authAPI, adminAPI, notifyAPI, baseURLs, reactURL };

//@Add Tutor Endpoint
//http://localhost:8091/bookmytuition/admin/addTutor?creatorUserId=4
